import React, { useState, useEffect, useRef } from 'react';
import { Box, Paper, TextField, Button, Typography, Link, Grid } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../other/auth';
import Cookies from 'js-cookie';
import tvbotImage from './tvbot.png';  // Import your image here

const Login = ({ url }) => {
  const [dns, setDns] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [blur, setBlur] = useState();
  const [m3u8, setM3u8] = useState(window.m3u8warning === true && !Cookies.get('m3u8_play'));

  const history = useHistory();
  const auth = useAuth();
  const inputRef = useRef(null);

  useEffect(() => {
    if (auth.isAuth()) {
      history.push(url || '/');
    } else {
      auth.authLogin(() => history.push(url || '/'));
    }
  }, [auth, history, url]);

  useEffect(() => {
    m3u8 ? setBlur({ filter: 'blur(.3rem)' }) : setBlur({});
  }, [m3u8]);

  const login = (e) => {
    e.preventDefault();
    setBlur({ filter: 'blur(.3rem)' });
    auth.signin(dns, username, password, () => window.location = '/', (title, description) => {
      setShowPopup({ title: title, description: description });
    });
  };

  const closePopup = () => {
    setBlur({ filter: 'blur(0)' });
    setShowPopup(false);
    inputRef.current.focus();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100vw',
        backgroundColor: '#000',
        padding: 0,
        overflow: 'hidden',
      }}
    >
      <Paper
        elevation={6}
        sx={{
          display: 'flex',
          width: '90%',
          maxWidth: 1200,  // Adjusted for larger screen size
          height: '80%',  // Increased height for better balance
          borderRadius: 2,
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            width: '65%',  // Make the image much wider
            backgroundImage: `url(${tvbotImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
        <Box
          component="form"
          onSubmit={login}
          sx={{
            width: '35%',  // Form size adjusted to match the image provided
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            px: 6,  // Reduced padding to match the image's spacing
            py: 7,  // Reduced padding to position the form elements correctly
            background: 'linear-gradient(to bottom, #1F2A36, #3A5060)',
            color: '#ECF0F1',
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 700, color: '#FFFFFF', mb: 1 }}>
            Sign In
          </Typography>
          {!window.dns && (
            <TextField
              variant="filled"
              fullWidth
              margin="dense"  // Less margin between fields
              label="Provider URL"
              placeholder="http://domain.com:80"
              onChange={(e) => setDns(e.target.value)}
              value={dns}
              autoFocus
              InputLabelProps={{ style: { color: '#ECF0F1', fontSize: '0.875rem' } }}  // Smaller label font
              InputProps={{ style: { color: '#ECF0F1', fontSize: '0.875rem' } }}  // Smaller input font
            />
          )}
          <TextField
            variant="filled"
            fullWidth
            margin="dense"
            label="Username"
            placeholder="Username"
            onChange={(e) => setUsername(e.target.value)}
            value={username}
            autoFocus={!!window.dns}
            inputRef={window.dns ? inputRef : null}
            InputLabelProps={{ style: { color: '#ECF0F1', fontSize: '0.875rem' } }}
            InputProps={{ style: { color: '#ECF0F1', fontSize: '0.875rem' } }}
          />
          <TextField
            variant="filled"
            fullWidth
            margin="dense"
            label="Password"
            type="password"
            placeholder="****"
            onChange={(e) => setPassword(e.target.value)}
            value={password}
            InputLabelProps={{ style: { color: '#ECF0F1', fontSize: '0.875rem' } }}
            InputProps={{ style: { color: '#ECF0F1', fontSize: '0.875rem' } }}
          />

          <Button
            variant="contained"
            fullWidth
            type="submit"
            onClick={login}
            onKeyDown={(e) => { if (e.keyCode === 13 || e.key === 'Enter') login(e); }}
            sx={{
              mt: 2,
              bgcolor: '#3498DB',
              color: '#ECF0F1',
              py: 1,
              fontSize: '0.875rem',  // Smaller font size
            }}
          >
            Sign In
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default Login;
